import { Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import * as moment from 'moment/moment';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {CsvService} from 'angular2-json2csv';
import { DialogService,DialogComponent} from 'ng2-bootstrap-modal';
import {AlertHistoryComponent} from '../alert-history/alert-history.component';
import { Popup } from 'ng2-opd-popup';

@Component({
  selector: 'app-inactive-customer-report',
  templateUrl: './inactive-customer-report.component.html',
  styleUrls: ['./inactive-customer-report.component.scss']
})
export class InactiveCustomerReportComponent implements OnInit {
  listContractLevel=[];
  ListTechnicianName=[];
  finalArr=[];
  techinicianDetails=[];
	ListAllHistroyDetails=[];
	AllMakedetails=[];
	AllModalDetails=[];

  loading:boolean=true;
	ListOfPreventiveMaintenanceDetails = [];
	ListFourMonthServiceDetails = [];
	FinalList = [];
	ListOfCustomerMaster = [];
	customerDetails = [];
	CustomerName:any;
	ListAllServcieType=[];
	ServiceType:any;

	histroy:any[]=[];
	clientName:any;
	serialNumber:any;
	mcLocation:any;
	phoneNumber:any;
	email:any;
	make:any;
	model:any;
	hmrHours:any;
	technicianName:any;
	lastServiceType:any;
	lastServiceHours:any;
	yearOfManufacture:any;
	branch:any;
	serviceContractOfferedYear:any;
	contractReference:any;
	noofServiceContractYears:any;
	startDate:any;
	endDate:any;
	noOfservice:any;
	serviceRemainderDays:any;
	currentService:any;  
	ListserviceDetails:any;
	histroyPP:any[] = [];
	reqmodelId;
	reqMakeId;
	newstartdate:any;
	newenddate:any;
	@ViewChild('Histroy') Histroy: Popup;
	ServiceContractExtend = [];
	extensionUpdateId;
  startingCount:number = 0;
  endingCount:number = 0;
  p: number = 1;
  histroyPr = [];
  todaydate:any;
  fourmonthdate:any;
  orgId:number;
  userId:number;
  ListbranchDetails:any[]=[];
	constructor(private dialogservice:DialogService,private http: Http,private router:Router,private route : ActivatedRoute,private csvService: CsvService) { }

	ngOnInit() {
   // this.loading=true;

    if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
        window.location.href = 'https://still.alshirawi.com/highmessaging/';
    } else {
      this.orgId=this.route.params['value'].orgId;
      this.userId=this.route.params['value'].userId;
      console.log('OrgId '+ this.orgId);
      console.log('UserId '+ this.userId);
    }
		this.getAllServiceTypeDetails()
		this.getAllPreventiveMaintenanceDetails();
    this.getAllDetailsFromCustomerMaster ();
    this.getTechnicianName();
    this.getBranchDetails();
		//	this.getmodeldetails();
			this.getmakedetailsforhistory();
			this.getmodeldetailsforhistory();
	}

	exportToExcel(event) {
	    this.csvService.download(this.FinalList, 'Inactive Report');
  }
  
  getBranchDetails(){
    let obj={
     'orgId':this.orgId
    }
    return this.http.post('/api/getbranchdetails',obj).subscribe(res=>{
       this.ListbranchDetails=res.json();
    })
   }

	getmodeldetails() {
      let modelObj = {
        'modelId':this.reqmodelId,
        'orgId':this.orgId
      }
      return this.http.post('/api/getModeldetailsBasedOnId', modelObj).subscribe(
       res => {
         let response = res.json();
         if(response.length>0) {
           this.model = response[0].model.toUpperCase();;
         }
       })
    }

    getmakedetails() {
      let makeObj = {
        'makeId':this.reqMakeId,
        'orgId':this.orgId
      }
      return this.http.post('/api/getMakedetailsBasedOnId', makeObj).subscribe(
       res => {
         let response = res.json();
         if(response.length>0) {
           this.make = response[0].make.toUpperCase();;
         }
       })
    }
  	getmodeldetailsforhistory() {
      // this.loading=true;
         let modelObj = {
           'orgId':this.orgId
         }
         return this.http.post('/api/getModelDetails', modelObj).subscribe(
          res => {
                 
            this.AllModalDetails = [];
            let response = res.json();
            if(response.length>0) {
              this.AllModalDetails =response;
              //this.model = response[0].model.toUpperCase();;
            }else{
              this.loading=false;
            }
          },(err)=>{
            this.loading=false;
          //	this.spinner.hide();
          })
       }

       getmakedetailsforhistory() {
  
        let makeObj = {
          'orgId':this.orgId
        }
        return this.http.post('/api/getMakedetails', makeObj).subscribe(
         res => {
                
           this.AllMakedetails=[];
           let response = res.json();
           if(response.length>0) {
             this.AllMakedetails = response;
             
           }else{
             this.loading=false;
           }
         },(err)=>{
           this.loading=false;
          // this.spinner.hide();
         })
      }
  

    getTechnicianName() {
    	let techObj = {
        'orgId':this.orgId
      	}
		return this.http.post('/api/getTechniciansName', techObj).subscribe(
	    res => {
        	res.json();
	    	this.ListTechnicianName = res.json();
	        let technicianArr = []
	        for(var i=0;i<this.ListTechnicianName.length;i++) {
	          let obj = {
	            'label':this.ListTechnicianName[i].FIRST_NAME +' '+ this.ListTechnicianName[i].LAST_NAME,
	            'value':this.ListTechnicianName[i].ID
	          }
	          technicianArr.push(obj);
	        }
	        this.techinicianDetails = technicianArr;
		},(err)=>{
      this.loading=false;
    })
	}
  showAlert(){
           
      console.log("ListAllHistroyDetails",this.ListAllHistroyDetails)
		  this.dialogservice.addDialog(AlertHistoryComponent,{title:'View History',values:this.ListAllHistroyDetails,contractlevelArr:this.listContractLevel,'finalArr':this.finalArr,'customIndex':0})
      // this.dialogservice.addDialog(AlertHistoryComponent,{title:'View History',clientName:this.clientName,
      //   HMRHours:this.hmrHours,ContractReference:this.contractReference,
      //   SerialNumber:this.serialNumber,TechnicianName:this.technicianName,NoOfServiceContractYears:this.noofServiceContractYears
      //   ,MCLocation:this.mcLocation,LastSerivceType:this.lastServiceType,StartDate:this.startDate,PhoneNumber:this.phoneNumber
      //   ,LastServiceHours:this.lastServiceHours,EndDate:this.endDate,
      //   Email:this.email,YearOfManufacture:this.yearOfManufacture,noOfservice:this.noOfservice,
      //   Make:this.make,Branch:this.branch,ServiceRemainderDay:this.serviceRemainderDays,Modal:this.model,
      //   ServiceContractOfferedYear:this.serviceContractOfferedYear,
      //   currentService:this.currentService,histroyPP:this.histroyPP,ListserviceDetails:this.ListserviceDetails,histroyPr:this.histroyPr
      //   ,ServiceContractExtend:this.ServiceContractExtend});
      // this.dialogservice.addDialog(AlertHistoryComponent,{title:this.Getmessage,message:"adasSSSSSSSSS"})
    }
	getAllServiceTypeDetails() {
      let ServiceTypeObj = {
        'orgId':this.orgId
      }
	    return this.http.post('/api/getServiceTypedetails', ServiceTypeObj).subscribe(
        res => {
           
           if(res.json().length>0){
            this.ListAllServcieType = res.json();
           }else{
             this.loading=false;
           }
           //this.loading=false;
        },(err)=>{
          this.loading=false;
       		alert('unable to load make values')
        })
	}

	getAllDetailsFromCustomerMaster () {
      let customerObj = {
        'orgId':this.orgId
      }
  		return this.http.post('/api/getCustomerMasterDetails', customerObj).subscribe(
     	res => {
     		     
         this.ListOfCustomerMaster = res.json();
         if(res.json().length>0){
          for(var i=0;i<this.ListOfCustomerMaster.length;i++) {
            let obj = {
              'Id':this.ListOfCustomerMaster[i]._id,
              'Name':this.ListOfCustomerMaster[i].customer_Name
            }
            this.customerDetails.push(obj);
          }
         }else{
           this.loading=false;
         }
     		
      	},(err)=>{
          this.loading=false;
        })
  	}

	getAllPreventiveMaintenanceDetails() {
    // this.loading=true
      let PMSObj = {
        'orgId':this.orgId
      }
      return this.http.post('/api/getAllPreventiveMaintenanceDetails', PMSObj).subscribe(
       res => {
       	     
       		let PMSReponse = res.json();
       		if(PMSReponse.length>0) {
       			for(let i=0;i<PMSReponse.length;i++) {
       				let snObj = {
       					'serialNumber':PMSReponse[i].serial_Number
       				}
       				this.ListOfPreventiveMaintenanceDetails.push(snObj);
       			}
       			this.todaydate = moment().format('YYYY-MM-DD');
		    	  this.fourmonthdate = moment(this.todaydate).subtract(4, 'M').format('YYYY-MM-DD');
		    	let reqObj = {
		    		'fromDate': this.fourmonthdate,
		    		'toDate':moment(this.todaydate).add(1, 'days').format('YYYY-MM-DD'),
            'orgId':this.orgId
		    	}
		    	return this.http.post('/api/getFourMonthServiceDetailsForInactive', reqObj).subscribe(
			        res => {
			        	     
		       		let Reportresponse = res.json();
               console.log("Reportresponse length " + Reportresponse.length);
		       		for(let i=0;i<Reportresponse.length;i++) {
                 
		       			let sdObj = {
		       				'serialNumber':Reportresponse[i].serialNumber
		       			}
		       			this.ListFourMonthServiceDetails.push(sdObj);
		       			
		       		}
		       		let result = [];
		       		for(var a=0;a<this.ListOfPreventiveMaintenanceDetails.length;a++) {
                  let serialCount=0;
		       			for(var b=0;b<this.ListFourMonthServiceDetails.length;b++) {
                    if(this.ListOfPreventiveMaintenanceDetails[a].serialNumber == this.ListFourMonthServiceDetails[b].serialNumber) {
                       serialCount=1;
		       				}
		       			}
                  if(serialCount == 0) {
                    result.push(this.ListOfPreventiveMaintenanceDetails[a].serialNumber);
                  }
		       		}
		      
		       		console.log("difference " + result);
              if(result.length <= 0) {
                this.loading=false;
                return;
              }
		       		let srreqObj = {
		       			'serialNumber':result
		       		}
		       		return this.http.post('/api/getInactiveReportDetails', srreqObj).subscribe(
			        res => {
			        		     	
                  let Finalresponse = res.json();
                
			        		for(var f=0;f<Finalresponse.length;f++) {
                    this.CustomerName = '';
                    this.ServiceType = '';

                    for(var k =0;k<this.customerDetails.length;k++) {
                      if(Finalresponse[f].client_Name == this.customerDetails[k].Id){
                        this.CustomerName = this.customerDetails[k].Name;
                      }
                    }

                    if(Finalresponse[f].Servicedetails && Finalresponse[f].Servicedetails.length > 0 && Finalresponse[f].serviceScheduleDay > 0 && Finalresponse[f].Servicedetails[Finalresponse[f].serviceScheduleDay-1]) {
                      for(var k=0;k<this.ListAllServcieType.length;k++) {
                        if(this.ListAllServcieType[k]._id == parseInt(Finalresponse[f].Servicedetails[Finalresponse[f].serviceScheduleDay-1].service_Type)) {
                          this.ServiceType = this.ListAllServcieType[k].servicetype;
                        }
                      }
                    }
                         
                    let StartDate = moment(Finalresponse[f].start_Date).format('YYYY-MM-DD');
                    let ToDate = moment(this.todaydate).add(1, 'days').format('YYYY-MM-DD');
                    if(StartDate >= this.fourmonthdate && StartDate <= ToDate){

                    } else {
                      let finalObj = {
                        'customerName':this.CustomerName,
                        'phone_Number':Finalresponse[f].phone_Number,
                        'contractLevel':Finalresponse[f].contractLevel,
                        'location':Finalresponse[f].mcLocation,
                        'serialNumber':Finalresponse[f].serial_Number,
                        'serviceType':this.ServiceType,
                        'id':Finalresponse[f]._id,
                        'startdate':moment(Finalresponse[f].start_Date).format("D MMM YYYY"),
                        'enddate':moment(Finalresponse[f].end_Date).format("D MMM YYYY"),

                      }
                      if(Finalresponse[f].start_Date >= moment().format('YYYY-MM-DD')) {

                      } else {
                        this.FinalList.push(finalObj);
                        this.loading=false;
                      }
                    }
			        		}
                  this.getCount();
                  this.loading=false;
			        	},(err)=>{
                  this.loading=false;
                })
          },(err)=>{
            this.loading=false;
          })
          
           }else{
            this.loading=false;
           }
          //  
       },(err)=>{
         this.loading=false;
       })
    }

    getCount(){
     if(this.p < Math.ceil(this.FinalList.length/10)){
       this.startingCount = (this.p-1)*10;
       if(this.startingCount == 0){
         this.startingCount = 1;
       }
       this.endingCount = this.p*10;
     } else if(this.p == Math.ceil(this.FinalList.length/10)){
       let count = this.FinalList.length%10;
       this.startingCount = (this.p-1)*10;
       this.endingCount = this.startingCount + count;
       if(this.startingCount == 0){
         this.startingCount = 1;
         this.endingCount = count;
       }
     }
  }
    
    viewHistory(pmId, serialNumber) {
           
    let ReqObjValue = {
      'pmId':pmId
    }
    return this.http.post('/api/getHistoryDetailsBasedOnContractLevel', ReqObjValue).subscribe(
      res=>{ 
        this.histroy = res.json();

        this.ListAllHistroyDetails=[];
        for(let h=0;h<this.histroy.length;h++) {
          for(var k =0;k<this.customerDetails.length;k++) {
            if( this.histroy[0].client_Name == this.customerDetails[k].Id){
              this.clientName = this.customerDetails[k].Name
            }
            }
            //this.extensionUpdateId = this.histroy[h]._id
            for(let m=0;m<this.AllMakedetails.length;m++ ) {
            if(this.AllMakedetails[m]._id == parseInt(this.histroy[h].make)) {
                      
              this.make = this.AllMakedetails[m].make;
            }
            }

            for(let n=0;n<this.ListbranchDetails.length;n++){
              if(this.ListbranchDetails[n]._id==this.histroy[h].branch){
               this.histroy[h].branch=this.ListbranchDetails[n].branchAlias
              }
            }
      
            for(let md=0;md<this.AllModalDetails.length;md++ ) {
            if(this.AllModalDetails[md]._id == parseInt(this.histroy[h].model)) {
              this.model = this.AllModalDetails[md].model;
            }
            }
            for(let t=0;t<this.techinicianDetails.length;t++) {
            if(this.techinicianDetails[t].value == parseInt(this.histroy[h].technician_Name)) {
              this.technicianName = this.techinicianDetails[t].label;
            }
            }
            for(let ls=0;ls<this.ListAllServcieType.length;ls++) {
            if(this.ListAllServcieType[ls]._id == parseInt(this.histroy[h].last_Service_Type)) {
              this.lastServiceType = this.ListAllServcieType[ls].servicetype;
            }
            }
            if((this.lastServiceType==undefined||this.lastServiceType=="")&&this.histroy[h].last_Service_Type=="New Vehicle"){
              this.lastServiceType="New Vehicle"
             }
            for(let i=0;i<this.histroy[h].Servicedetails.length;i++) {
            for(let k=0;k<this.ListAllServcieType.length;k++) {
              if(parseInt(this.histroy[h].Servicedetails[i].service_Type) == this.ListAllServcieType[k]._id) {
              this.histroy[h].Servicedetails[i].service_Type = this.ListAllServcieType[k].servicetype;
              }
            }
            
            }
            let histroyObject = {
            'clientName':this.clientName,
            'pmId':this.histroy[h]._id,
            'serialNumber':this.histroy[h].serial_Number,
            'mcLocation':this.histroy[h].mcLocation,
            'phoneNumber':this.histroy[h].phone_Number,
            'email':this.histroy[h].email,
            'make':this.make,
            'modal':this.model,
            'hmr':this.histroy[h].hmr,
            'contractLevel':this.histroy[h].contractLevel,
            'technicianName':this.technicianName,
            'lastserviceType':this.lastServiceType,
            'lastServiceHours':this.histroy[h].last_Service_Hours,
            'yearOfManufacturer':this.histroy[h].year_Of_manufacturer,
            'branch':this.histroy[h].branch,
            'contractRefernce':this.histroy[h].contract_Reference,
            'noofServiceContractYears':this.histroy[h].noofServiceContractYear,
            'startDate':moment(this.histroy[h].start_Date).format("D MMM YYYY"),
            'endDate':moment(this.histroy[h].end_Date).format("D MMM YYYY"),
            'newstartdate':this.histroy[h].start_Date,
            'newenddate':this.histroy[h].end_Date,
            'noOfservice':this.histroy[h].no_Of_Service,
            'serviceRemainderDays':this.histroy[h].remainderday,
            'currentService':this.histroy[h].serviceScheduleDay,
            'ListserviceDetails': this.histroy[h].Servicedetails,
            'lastServiceStatusOfContract':'',
            'histroyPr':[],
            'histroyPp':[],
            'ServiceContractExtend':[]
      
                  }
                
                  this.ListAllHistroyDetails.push(histroyObject);
  
  
        }
  

      //   for(var k =0;k<this.customerDetails.length;k++) {
      //       if( this.histroy[0].client_Name == this.customerDetails[k].Id){
      //         this.clientName = this.customerDetails[k].Name
      //       }
      //     }
      // this.extensionUpdateId = this.histroy[0]._id
      // this.serialNumber = this.histroy[0].serial_Number;
      // this.mcLocation = this.histroy[0].mcLocation;
      // this.phoneNumber = this.histroy[0].phone_Number;
      // this.email = this.histroy[0].email;
      // this.reqMakeId = this.histroy[0].make;
      // this.getmakedetails();
      // this.reqmodelId = this.histroy[0].model;
      // this.getmodeldetails();
      
      // this.hmrHours = this.histroy[0].hmr;
      // this.technicianName = this.histroy[0].technician_Name;
      // this.lastServiceType = this.histroy[0].last_Service_Type;
      // this.lastServiceHours = this.histroy[0].last_Service_Hours;
      // this.yearOfManufacture = this.histroy[0].year_Of_manufacturer;
      // this.branch = this.histroy[0].branch;
      // this.serviceContractOfferedYear = this.histroy[0].service_Contract_Offered;
      // this.contractReference = this.histroy[0].contract_Reference;
      // this.noofServiceContractYears = this.histroy[0].noofServiceContractYear;
      // this.startDate = moment(this.histroy[0].start_Date).format("D MMM YYYY");
      // this.endDate = moment(this.histroy[0].end_Date).format("D MMM YYYY");
      // this.newstartdate = this.histroy[0].start_Date;
      // this.newenddate = this.histroy[0].end_Date;
      // this.noOfservice = this.histroy[0].no_Of_Service;
      // this.serviceRemainderDays = this.histroy[0].remainderday;
      // this.currentService = this.histroy[0].serviceScheduleDay;
      // for(let i=0;i<this.histroy[0].Servicedetails.length;i++) {
      //   for(let k=0;k<this.ListAllServcieType.length;k++) {
      //     if(parseInt(this.histroy[0].Servicedetails[i].service_Type) == this.ListAllServcieType[k]._id) {
      //       this.histroy[0].Servicedetails[i].service_Type = this.ListAllServcieType[k].servicetype;
      //     }
      //   }
        
      // }
      // this.ListserviceDetails = this.histroy[0].Servicedetails
        let reqObj = {
          'serialNumber':serialNumber,
        }
        return this.http.post('/api/getListAllPostPonedHistroy', reqObj).subscribe(
        res=>{ 
               
          let ppHis = res.json();
           this.histroyPP = [];
           this.histroyPr = [];
           if(ppHis.length>0) {
            for(var p=0;p<ppHis.length;p++) {
              if(ppHis[p].type == 'servicePrepone') {
                let pphis = {
                  'serialNumber':ppHis[p].serialNumber,
                  'postPoned_Taken_Date':moment(ppHis[p].postPoned_Taken_Date,).format("D MMM YYYY"),
                  'postPoned_Remainder_Days':ppHis[p].postPoned_Remainder_Days,
                  'schedularNumber':ppHis[p].schedularNumber
                }
                this.histroyPr.push(pphis);
                for(let pr=0;pr<this.ListAllHistroyDetails.length;pr++) {
                  if(this.ListAllHistroyDetails[pr].serialNumber == ppHis[p].serialNumber && this.ListAllHistroyDetails[pr].contractLevel == ppHis[p].contractLevel) {
                    this.ListAllHistroyDetails[pr].histroyPr = this.histroyPr;
                  }
                } //for loop end here

              } else if(ppHis[p].type == 'servicePostpone') {
                let pphis = {
                  'serialNumber':ppHis[p].serialNumber,
                  'postPoned_Taken_Date':moment(ppHis[p].postPoned_Taken_Date,).format("D MMM YYYY"),
                  'postPoned_Remainder_Days':ppHis[p].postPoned_Remainder_Days,
                  'schedularNumber':ppHis[p].schedularNumber
                }
                this.histroyPP.push(pphis);
                for(let pp=0;pp<this.ListAllHistroyDetails.length;pp++) {
                  if(this.ListAllHistroyDetails[pp].serialNumber == ppHis[p].serialNumber && this.ListAllHistroyDetails[pp].contractLevel == ppHis[p].contractLevel) {
                    this.ListAllHistroyDetails[pp].histroyPp = this.histroyPP;
                  }
                } //for loop end here
              }
              
              
              
            }
          }
          
          let reqExtendobj = {
            'serialNumber':serialNumber,
          }
          return this.http.post('/api/getListAllServiceContractExtendHistroy', reqObj).subscribe(
          res=>{ 
            let SCExtend = res.json();
            this.ServiceContractExtend = [];
            if(SCExtend.length>0) {
              for(var n=0;n<SCExtend.length;n++) {
                let SCEobj = {
                  'serialNumber':SCExtend[n].serialNumber,
                  'startdate':moment(SCExtend[n].startdate).format("D MMM YYYY"),
                  'enddate':moment(SCExtend[n].enddate).format("D MMM YYYY"),
                  'contractExtensionDate':moment(SCExtend[n].contractExtensionDate).format("D MMM YYYY")
                }
                this.ServiceContractExtend.push(SCEobj);
              }
            }
            let statusObj = {
              'pmId':this.ListAllHistroyDetails[0].pmId,
              'serialNumber':this.ListAllHistroyDetails[0].serialNumber
            }
            return this.http.post('/api/serviceStatusChecking_serviceFormAPI', statusObj).subscribe(
            res => {
              
              let response = res.json();
              if(response.length > 0) {
                if(response[response.length-1].service_Scheduler_Number == this.ListAllHistroyDetails[0].noOfservice && response[response.length-1].status == 1) {
                  this.ListAllHistroyDetails[0].lastServiceStatusOfContract = 'completed';
                } else {
                  this.ListAllHistroyDetails[0].lastServiceStatusOfContract = 'notcompleted';
                }
              }
              this.showAlert();
            })
            // this.Histroy.options = {
            //   showButtons: false, // You can hide this in case you want to use custom 
            //   color: "#4180ab",
            //   widthProsentage:80,
            //   header: "Histroy"
            // };
            // this.Histroy.show(this.Histroy.options);
            
          })
          
        })
        
      })
     
    }

    close() {
      this.Histroy.hide();
    }


}



// WEBPACK FOOTER //
// ./client/app/inactive-customer-report/inactive-customer-report.component.ts